import { AppController } from "../AppController";
var ServerErrorPage = /** @class */ (function () {
    function ServerErrorPage(_appController) {
        this._appController = _appController;
    }
    Object.defineProperty(ServerErrorPage.prototype, "appController", {
        get: function () {
            return this._appController;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ServerErrorPage.prototype, "errorMessage", {
        get: function () {
            return this._appController.latestErrorMessage;
        },
        enumerable: true,
        configurable: true
    });
    return ServerErrorPage;
}());
export { ServerErrorPage };
